import { l } from '@manychat/manyui'

import { shortNumber } from 'utils'
import { NodeType } from 'common/builder/constants/NodeType'
import { INode } from 'common/builder/nodes/nodeInterfaces'
import { formatCTR } from 'utils/stats'

export type INodeStatsItem = null | {
  title: string
  value: string
  hoverValue: string | null
  segment: string
}

export interface IGetNodeStatsItemsOptions {
  isRootNodeSelected?: boolean
  isStatByJSONAdsTrigger?: boolean
}

export const getNodeStatsItems = (
  node: INode,
  options: IGetNodeStatsItemsOptions,
): INodeStatsItem[][] => {
  const { stats } = node

  if (!stats) {
    return []
  }

  const SentItem = {
    title: l.translate('Sent'),
    value: shortNumber(stats.sentUsers),
    hoverValue: '',
    segment: stats.sentSegmentId,
  }
  const DeliveredItem = {
    title: l.translate('Delivered'),
    value: `${stats.dr}%`,
    hoverValue: shortNumber(stats.deliveredUniqueUsers),
    segment: stats.deliveredSegmentId,
  }
  const OpenedItem = {
    title: l.translate('Opened'),
    value: `${stats.rr}%`,
    hoverValue: shortNumber(stats.readUniqueUsers),
    segment: stats.readSegmentId,
  }

  const clickCTR = node.nodeType === NodeType.TELEGRAM ? stats.ctrBySent : stats.ctr
  const ClickedItem = {
    title: l.translate('Clicked'),
    value: formatCTR(clickCTR, 1),
    hoverValue: shortNumber(stats.clicksUsers),
    segment: stats.clickedSegmentId,
  }

  if (node.nodeType === NodeType.EMAIL_NEW) {
    const BouncedItem = {
      title: l.translate('Bounced'),
      value: shortNumber(stats.bounced),
      hoverValue: ``,
      segment: stats.bouncedSegmentId,
    }
    const SpamReportItem = {
      title: l.translate('Spam Report'),
      value: shortNumber(stats.spamReport),
      hoverValue: ``,
      segment: stats.spamReportSegmentId,
    }
    const UnsubscribedItem = {
      title: l.translate('Unsubscribed'),
      value: shortNumber(stats.unsubscribed),
      hoverValue: ``,
      segment: stats.unsubscribedSegmentId,
    }
    return [
      [SentItem, DeliveredItem, OpenedItem, ClickedItem],
      [BouncedItem, SpamReportItem, UnsubscribedItem, null],
    ]
  }
  if (node.nodeType === NodeType.INSTAGRAM) {
    return [[SentItem, DeliveredItem, OpenedItem, ClickedItem]]
  }
  if (node.nodeType === NodeType.CONTENT) {
    if (options.isStatByJSONAdsTrigger && options.isRootNodeSelected) {
      const FirstNodeByJSONAdsSentItem = { ...SentItem, value: '-', hoverValue: null }
      const FirstNodeByJSONAdsDeliveredItem = { ...DeliveredItem, value: '-', hoverValue: null }
      const FirstNodeByJSONAdsOpenedItem = { ...OpenedItem, value: '-', hoverValue: null }
      const FirstNodeByJSONAdsClickedItem = {
        ...ClickedItem,
        value: shortNumber(stats.clicksUsers),
        hoverValue: null,
      }
      return [
        [
          FirstNodeByJSONAdsSentItem,
          FirstNodeByJSONAdsDeliveredItem,
          FirstNodeByJSONAdsOpenedItem,
          FirstNodeByJSONAdsClickedItem,
        ],
      ]
    }
    return [[SentItem, DeliveredItem, OpenedItem, ClickedItem]]
  }
  if (node.nodeType === NodeType.SMART_DELAY) {
    const OverallItem = {
      title: l.translate('Overall'),
      value: shortNumber(stats.sentUnique),
      segment: stats.sentSegmentId,
      hoverValue: null,
    }
    const WaitingItem = {
      title: l.translate('Waiting'),
      value: shortNumber(stats.waitersUnique),
      segment: stats.waitersSegmentId,
      hoverValue: null,
    }
    const PassedItem = {
      title: l.translate('Passed'),
      value: shortNumber(stats.deliveredUnique),
      segment: stats.deliveredSegmentId,
      hoverValue: null,
    }
    return [[OverallItem, WaitingItem, PassedItem]]
  }
  if (node.nodeType === NodeType.SMS) {
    return [[SentItem, DeliveredItem, ClickedItem]]
  }
  if (node.nodeType === NodeType.WHATS_APP) {
    return [[SentItem, DeliveredItem, ClickedItem]]
  }
  if (node.nodeType === NodeType.TELEGRAM) {
    return [[SentItem, ClickedItem]]
  }
  if (node.nodeType === NodeType.TIKTOK) {
    return [[SentItem, DeliveredItem, OpenedItem, ClickedItem]]
  }
  if (node.nodeType === NodeType.AI_AGENT) {
    return [
      [
        {
          title: l.translate('Started'),
          value: shortNumber(stats.startedUnique),
          hoverValue: '',
          segment: stats.sentSegmentId,
        },
        {
          title: l.translate('Finished'),
          value: stats.startedUnique
            ? `${Number(((stats.finishedUnique / stats.startedUnique) * 100).toFixed(2))}%`
            : '0%',
          hoverValue: shortNumber(stats.finishedUnique),
          segment: '',
        },
      ],
    ]
  }
  return []
}
